import React, { useState, useEffect, useContext } from "react";
import { Link } from "gatsby";
import Arrow from "assets/rightarrow.svg";
import {
  Services,
  Languages,
  AboutData,
  Industries,
  Services2,
  TranslationData,
  LocalizationData,
  InterpretationData,
  IndustryExpertiseData,
  ToolsLinks,
  HeaderToolsList,
} from "./config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faUser,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import tomedesLogo from "assets/images/Tomedes_Logo.svg";
import DataProvider from "Context/DataContext";
// import TrustpilotReviews from "@pittica/gatsby-plugin-trustpilot-widget";
import greenIcon from "assets/green_circle.svg";
import toast from "react-hot-toast";
import Copy_icon from "assets/copy_icon.svg"

export default function Header() {
  const [hamburger, setHamburger] = useState(false);
  const [activeMenu, setActiveMenu] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [showName, setShowName] = useState(" ");

  const { LocalObject } = useContext(DataProvider);
  const [showTools, setShowTools] = useState(false);

  useEffect(() => {
    if (hamburger) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [hamburger]);

  // const listenToScroll = () => {
  //   let heightToHideFrom = 60;
  //   const winScroll =
  //     document.body.scrollTop || document.documentElement.scrollTop;

  //   if (winScroll > heightToHideFrom) {
  //     isVisible && setIsVisible(false);
  //   } else {
  //     setIsVisible(true);
  //   }
  // };
  // useEffect(() => {
  //   window.addEventListener("scroll", listenToScroll);
  //   return () => window.removeEventListener("scroll", listenToScroll);
  // }, []);

  let userName = " ";

  useEffect(() => {
    const userInfo = JSON.parse(LocalObject.localStorage.getItem("acc_info"));
    userName = userInfo?.user?.username;
    setShowName(userName);
  }, []);

  const caretDownFil = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      class="bi bi-caret-down-fill"
      viewBox="0 0 16 16"
    >
      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
    </svg>
  );
  const closeModalIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="currentColor"
      class="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );

  const useExperiment = (experimentId) => {
    const [variant, setVariant] = useState();
    useEffect(() => {
      (async () => {
        // if (window.dataLayer) {
        //   await window.dataLayer.push({ event: "optimize.activate" });
        // }
        const intervalId = setInterval(() => {
          if (window.google_optimize !== undefined) {
            // Set the variant to the state.
            setVariant(window.google_optimize.get(experimentId));
            clearInterval(intervalId);
          }
        }, 100);
      })();
    }, []);
    return variant;
  };
  const variant = useExperiment("_b1eORemTP6uefA63zaTlQ");
  // const variant = 1;
  const style = {
    background:
      "transparent linear-gradient(180deg, #000000 0%, #00173A 100%) 0% 0% no-repeat padding-box",
  };
  const toolsLinks = [
    {
      href: "/tools/translation-quality-assurance",
      text: "Translation Quality Assurance",
      hreflang: "en-us",
    },
    {
      href: "/tools/translation-difficulty-checker",
      text: "Translation Difficulty Checker",
    },
    {
      href: "/tools/guideline-adherence-checker",
      text: "Translation Guideline Adherence Checker",
    },
    {
      href: "/tools/topic-detection",
      text: "Topic Detection",
    },
    {
      href: "/tools/data-anonymization",
      text: "Data Anonymization",
    },
    {
      href: "/tools/glossary-generator",
      text: "Bilingual Glossary Generator",
    },
    {
      href: "/tools/translation-consistency-checker",
      text: "Translation Consistency Checker",
    },
    {
      href: "/tools/language-detector",
      text: "Language Detector",
    },
    {
      href: "/tools/text-summarizer",
      text: "Online Summarization",
    },
    {
      href: "/tools/word-count-ratio",
      text: "Word Count Ratio",
    },
  ];
  const showtoolsdata = () => {
    setShowTools(!showTools);
  };

  const handleCopy = (id) => {
    const textToCopy = document.getElementById(id);
    if (textToCopy) {
      navigator.clipboard
        .writeText(textToCopy.textContent)
        .then(() => {
          toast.success("Copied");
        })
        .catch((err) => {
          console.error("Failed to copy text:", err);
        });
    }
  };
  

  return (
    <>
      <div
        className="
           hidden lg:flex items-center justify-center w-full bg-black border-b border-quotetext-300 sticky top-0 z-[100]"
      >
        <div className=" sm:px-6 lg:px-0  max-w-7xl mx-auto  w-full flex items-center justify-between py-2 ">
          <div className="lg:w-[54%] flex items-center  ">
            {/* <TrustpilotReviews
            language="en"
            culture="US"
            theme="dark"
            width="100%"
            height="20px"
            template="5419b637fa0340045cd0c936"
            business="5b18d84cd3737d0001df3bec"
            username="USERNAME"
          /> */}
            <p  className="flex font-opensans font-normal mr-[17px] text-13 leading-5 text-[#A5A5A5] gap-4">
              {/* <a href="mailto:support@tomedes.com">support@tomedes.com</a> */}
         
                <span id="company-email">support@tomedes.com</span>
             
            
              <button
                
                href="mailto:support@tomedes.com"
                onClick={() => handleCopy("company-email")}
              >
              <img src={Copy_icon} alt="copy_icon" />
              </button>
              &nbsp;|&nbsp;
              <a href="tel:+19852390142">US: +1 985 239 0142</a>
              &nbsp;|&nbsp;
              <a href="tel:+441615096140">UK: +44 (0)16 1509 6140</a>
            </p>
          </div>
          <div className="lg:w-[46%] flex items-center justify-end ">
            <Link
              to="/user/login"
              className="text-13 text-white font-opensans flex items-center justify-center  mr-4"
            >
              <FontAwesomeIcon
                icon={faUser}
                className="text-white w-[10px] mr-6"
              />
              {showName ? showName : "ACCOUNT"}
            </Link>
            <Link
              to="/user/provider/createaccount"
              className="text-white text-[13px] leading-[19.5px] font-primary flex items-center border-r border-[#D9D9D9] border-l px-4"
            >
              Register as a Translator
            </Link>

            {/* <Link
            to="/translators"
            className="flex text-white text-[13px] leading-[19.5px] font-primary  items-center pl-[15px] border-[#D9D9D9] "
          >
            Our Translators
          </Link> */}
            {/* <div className="px-3  border-r border-[#D9D9D9] font-opensans xs:font-secondary text-14 text-gray hover:text-orange flex justify-center items-center gap-2 relative group cursor-pointer">
              <button>
                {" "}
                <Link to="/tools">Tools</Link>
              </button>

              <span>{caretDownFil}</span>
              <div className="absolute top-0  z-[101] mt-[22px] pt-1  hidden group-hover:block">
                <div className="usa_modal_body bg-white  p-6  space-y-5 min-w-[320px] h-[250px] overflow-y-scroll">
                  {toolsLinks?.map((link, index) => (
                    <Link
                      key={index}
                      href={link.href}
                      hreflang={link.hreflang}
                      className="text-black font-opensans text-sm leading-4 hover:text-lightBlue block"
                    >
                      {link.text}
                    </Link>
                  ))}
                </div>
              </div>
            </div> */}
            <div className="ml-4 font-opensans xs:font-secondary text-14 text-gray hover:text-orange flex justify-center items-center gap-2 relative group cursor-pointer">
              <img
                src="https://tomedes.gumlet.io/assets/images/usa.svg"
                alt="language"
                width="18"
                height="13"
              />{" "}
              <span>USA - EN</span> <span>{caretDownFil}</span>
              <div className="absolute top-0 z-[101] pt-[29px] hidden group-hover:block">
                <div className="usa_modal_body bg-white  pl-4 py-2 space-y-3 w-[234px] h-[250px] overflow-y-scroll">
                  <a
                    hreflang="en-us"
                    href="https://www.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    English
                  </a>
                  <a
                    hreflang="es"
                    href="https://es.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Español
                  </a>
                  <a
                    hreflang="cn"
                    href="https://cn.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    简体中文
                  </a>
                  <a
                    hreflang="cn"
                    href="https://tw.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    中國傳統的
                  </a>
                  <a
                    hreflang="de"
                    href="https://de.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Deutsch
                  </a>
                  <a
                    hreflang="fr"
                    href="https://fr.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Français
                  </a>
                  <a
                    hreflang="nl"
                    href="https://nl.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Nederlands
                  </a>
                  <a
                    hreflang="he"
                    href="https://www.tomedes.co.il/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    עברית
                  </a>
                  <a
                    hreflang="ja"
                    href="https://jp.tomedes.com"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    日本語
                  </a>
                  <a
                    hreflang="ko"
                    href="https://kr.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    한국어
                  </a>
                  <a
                    hreflang="nb"
                    href="https://no.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Norsk
                  </a>
                  <a
                    hreflang="pl"
                    href="https://pl.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Polski
                  </a>
                  <a
                    hreflang="ro"
                    href="https://ro.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Româna
                  </a>
                  <a
                    hreflang="sv"
                    href="https://sv.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Svenska
                  </a>
                  <a
                    hreflang="tr"
                    href="https://tr.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Türk
                  </a>
                  <a
                    hreflang="ru"
                    href="https://ru.tomedes.com/"
                    target="_blank"
                    className="text-black hover:text-lightBlue block"
                  >
                    Русский
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section
        className={`header-wrapper sticky top-0 lg:top-[38px]
           left-0 right-0 z-[99] bg-black lg:flex lg:flex-col lg:items-center lg:justify-center px-4 ${
             hamburger ? "h-screen lg:h-auto overflow-y-scroll" : ""
           }`}
      >
        <div className="flex items-center justify-between lg:flex-row flex-col py-5 sm:py-6 sm:p-6 lg:p-0  max-w-screen-xl w-full">
          <div className="logo flex justify-between items-center w-full text-left">
            <Link to="/" className="hidden lg:block">
              <img
                src={tomedesLogo}
                alt="logo"
                className="w-[150px] md:w-[unset]"
              />
            </Link>
            {isVisible && (
              <Link to="/" className="lg:hidden">
                <img
                  src={tomedesLogo}
                  alt="logo"
                  className="w-[150px] md:w-[unset] h-8"
                />
              </Link>
            )}
            {!isVisible && (
              <Link
                to="/quote"
                className="uppercase rounded-full bg-orange hover:bg-newOrange-100 text-white cursor-pointer text-14 font-semibold py-1 px-4 text-center transition-all duration-300 lg:hidden h-8 flex items-center"
              >
                {variant == "1" ? "START TRANSLATION" : " Translate Now"}
              </Link>
            )}

            <Link
              to="/contactus.php"
              className="lg:hidden flex items-center sm:gap-2.5 gap-1.5 absolute text-white sm:right-[105px] right-[72px] border-[1.5px] border-white rounded-full py-1.5 sm:px-4 px-3 text-[12px] font-bold font-opensans"
            >
              <img src={greenIcon} />
              <span> CONTACT US</span>
            </Link>
            {hamburger ? (
              <div
                className="w-8 lg:hidden h-8 bg-white text-black text-center flex items-center justify-center text-xl rounded-full"
                onClick={() => setHamburger(!hamburger)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </div>
            ) : (
              <div
                className="lg:hidden flex flex-col items-center justify-center"
                onClick={() => setHamburger(!hamburger)}
              >
                <span className="inline-block h-1.5  w-10 rounded-lg bg-white"></span>
                <span className="inline-block h-1.5  w-10 my-1.5 rounded-lg bg-white"></span>
                <span className="inline-block h-1.5  w-10 rounded-lg bg-white"></span>
              </div>
            )}
          </div>
          {/* <p className="font-normal text-12 leading-5 font-opensans xs:font-secondary text-[#A5A5A5] self-baseline pt-5 pr-3 lg:hidden">
            <a href="mailto:support@tomedes.com">support@tomedes.com</a>
            <span className="block">
              <a href="tel:+19852390142">US: +1 985 239 0142</a>
              &nbsp;|&nbsp;
              <a href="tel:+441615096140">UK: +44 (0)16 1509 6140</a>
            </span>
          </p> */}
          <section
            className={`${hamburger ? "block" : "hidden"} w-full lg:block`}
          >
            <nav className="lg:flex items-center text-base justify-center relative">
              <ul
                className="nav menu list lg:mt-0 mt-[50px]  font-normal flex lg:items-center font-opensans lg:flex-row flex-col text-white"
                // style={{ WebkitTapHighlightColor: "transparent" }}
              >
                <li
                  className="languages_menu focus:outline-none leading-[16px] lg:px-4 lg:py-10 
               lg:mb-0 mb-[34px] px-3 mx-1 text-sm w-full inline-block group relative"
                >
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(
                        activeMenu === "translation" ? false : "translation"
                      )
                    }
                  >
                    <Link to="/translation-services">Translation</Link>
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "translation"
                          ? "rotate-180 text-orange"
                          : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    style={{ paddingBottom: "40px" }}
                    className={`${
                      activeMenu === "translation" ? "block" : "hidden"
                    } nav menu list languages_menu_child lg:bg-[#060606] bg-transparent text-white w-[300px] lg:absolute focus:outline-none  lg:mt-[-5px] mt-[10px] left-0  px-[25px] 
                    pt-[25px]   transition-all duration-500  z-10  rounded-b-lg top-[100px] lg:border-t lg:border-[#CECECE]`}
                  >
                    {TranslationData?.map(({ list, link }, index) => (
                      <li className="sm:w-auto hover:text-orange hover:underline hover:underline-offset-4 text-left mb-[25px] last-of-type:mb-0 leading-[16px] text-sm font-opensans  font-normal">
                        <Link to={link} key={index}>
                          <div className="">{list}</div>
                        </Link>
                      </li>
                    ))}
                    {/* <div className="bg-[#001533] pt-[14px]">
                      {Services2?.map(({ list, link, byline }, index) => (
                        <li className="px-[40px] w-auto sm:w-80 hover:text-orange text-left text-base  font-opensans xs:font-secondary bg-[#001533] font-normal">
                          <Link to={link} key={index}>
                            <div
                              className={`${
                                index == 1 || index == 0
                                  ? "text-base sm:text-base py-[6px]"
                                  : " text-base md:text-base"
                              }`}
                            >
                              {list}
                            </div>
                            <div className="text-12 md:text-13 mt-2 text-newgray mb-4">
                              {byline}
                            </div>
                          </Link>
                        </li>
                      ))}
                    </div> */}
                  </ul>
                </li>
                {/* <li className="languages_menu leading-[19px] w-full  lg:px-6 lg:py-10 lg:mb-0 mb-[34px] px-3 mx-1 text-base group">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(
                        activeMenu === "localization" ? false : "localization"
                      )
                    }
                  >
                    <Link to="/localization-services">Localization</Link>
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "localization"
                          ? "rotate-180 text-orange"
                          : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={` ${
                      activeMenu === "localization" ? "block" : "hidden"
                    } languages_menu_child lg:bg-[#060606] bg-transparent text-white w-[300px] lg:mt-0 mt-[10px] left-[142px] top-[100px] lg:border-t lg:border-[#CECECE] z-10  lg:absolute 
                    px-[25px] pt-[25px] pb-40 rounded-b-lg `}
                    // style={style}
                  >
                    {LocalizationData?.map(
                      ({ list, img_link, link, underline }, i) => (
                        <li
                          key={i}
                          className="sm:w-auto hover:text-orange hover:underline hover:underline-offset-4 text-left text-base font-opensans font-normal mb-[25px] last-of-type:mb-0"
                        >
                          <Link
                            to={link}
                            className={`hover:text-orange text-base font-normal font-opensans flex items-center`}
                          >
                            {img_link ? (
                              <img
                                src={img_link}
                                className="mr-2"
                                alt="loading..."
                              />
                            ) : (
                              ""
                            )}
                            {list && list}
                          </Link>
                        </li>
                      )
                    )}
                  </ul>
                </li> */}
                <li className="languages_menu leading-[16px] w-full lg:px-4 lg:py-10 lg:mb-0 mb-[34px] px-3 mx-1 text-sm group">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(
                        activeMenu === "interpretation"
                          ? false
                          : "interpretation"
                      )
                    }
                  >
                    <Link to="/interpretation-services ">Interpretation</Link>
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "interpretation"
                          ? "rotate-180 text-orange"
                          : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={` ${
                      activeMenu === "interpretation" ? "block" : "hidden"
                    } nav menu list languages_menu_child lg:bg-[#060606] bg-transparent text-white w-[300px] lg:mt-[-5px] mt-[10px] left-24 top-[100px] lg:border-t lg:border-[#CECECE] z-10  lg:absolute px-[25px] pt-[25px] pb-[40px] rounded-b-lg `}

                    // className={` ${
                    //   activeMenu === "interpretation" ? "block" : "hidden"
                    // } languages_menu_child bg-[#FBFBFB] text-black w-full lg:w-5/12 left-24 top-24 place-content-center place-items-center z-10 lg:absolute lg:pb-[10px] pb-8 lg:ml-[150px]`}
                    // style={style}
                  >
                    {InterpretationData?.map(({ list, link }, index) => (
                      <li
                        key={index}
                        className="hover:text-orange hover:underline hover:underline-offset-4 text-left leading-[16px] text-sm font-opensans font-normal mb-[25px] last-of-type:mb-0"
                      >
                        <Link
                          className={`hover:text-orange leading-[16px] text-sm font-normal font-opensans  flex items-center`}
                          to={link}
                        >
                          {list}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="languages_menu leading-[16px] w-full lg:px-4 lg:py-10 lg:mb-0 mb-[34px] px-3 mx-1 text-sm group">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(
                        activeMenu === "industry_expertise"
                          ? false
                          : "industry_expertise"
                      )
                    }
                  >
                    <Link to="/industries" className="lg:w-max ">
                      Industry
                    </Link>
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "industry_expertise"
                          ? "rotate-180 text-orange"
                          : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={` ${
                      activeMenu === "industry_expertise" ? "block" : "hidden"
                    } nav menu list languages_menu_child lg:bg-[#060606] bg-transparent text-white w-[250px] lg:mt-[-5px] mt-[10px] left-[240px] top-[100px] lg:border-t lg:border-[#CECECE] z-10  lg:absolute px-[25px] pt-[25px] pb-[40px] rounded-b-lg `}

                    // className={` ${
                    //   activeMenu === "interpretation" ? "block" : "hidden"
                    // } languages_menu_child bg-[#FBFBFB] text-black w-full lg:w-5/12 left-24 top-24 place-content-center place-items-center z-10 lg:absolute lg:pb-[10px] pb-8 lg:ml-[150px]`}
                    // style={style}
                  >
                    {IndustryExpertiseData?.map(({ list, link }, index) => (
                      <li
                        key={index}
                        className="hover:text-orange hover:underline hover:underline-offset-4 text-left leading-[16px] text-sm font-opensans font-normal mb-[25px] last-of-type:mb-0"
                      >
                        <Link
                          className={`hover:text-orange leading-[16px] text-sm font-normal font-opensans  flex items-center`}
                          to={link}
                        >
                          {list}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="languages_menu leading-[16px] w-full lg:px-4 lg:py-10 lg:mb-0 mb-[34px] px-3 mx-1 text-sm group">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(
                        activeMenu === "languages" ? false : "languages"
                      )
                    }
                  >
                    <Link to="/languages ">Languages</Link>
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "languages"
                          ? "rotate-180 text-orange"
                          : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={` ${
                      activeMenu === "languages" ? "block" : "hidden"
                    } nav menu list languages_menu_child  lg:bg-[#060606] bg-transparent text-white lg:mt-[-5px] mt-[10px] lg:w-[340px] w-full left-0 top-[100px] lg:border-t lg:border-[#CECECE] place-content-center place-items-start z-10 lg:absolute px-[25px] pt-[25px] pb-40 lg:ml-[320px] grid grid-cols-2 rounded-b-lg `}
                  >
                    {Languages?.map(({ list, link, img_link }, index) => (
                      <li
                        key={index}
                        className={`hover:text-orange hover:underline hover:underline-offset-4 font-normal font-opensans  ${
                          index === 0 || index === 1 ? "mt-0" : "mt-3"
                        }`}
                      >
                        <Link
                          className={`hover:text-orange leading-[16px] text-sm font-normal font-opensans py-1 flex items-center`}
                          to={link}
                        >
                          {img_link && <img src={img_link} alt={list} />}
                          <span className={`${img_link && "ml-[10px]"}`}>
                            {" "}
                            {list}
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="languages_menu leading-[16px] w-full lg:px-4 lg:py-10 lg:mb-0 mb-[34px] px-3 mx-1 text-sm group">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(activeMenu === "tools" ? false : "tools")
                    }
                  >
                    <Link to="/tools" className="w-max">
                      Free AI Tools
                    </Link>
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "tools" ? "rotate-180 text-orange" : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>

                  <ul
                    //  className={`${
                    //   activeMenu === "tools" ? "block" : "hidden"
                    // } items-center justify-center lg:bg-[#060606] bg-transparent text-white  lg:mt-[-5px] mt-[10px] rounded-b-lg top-[100px] lg:border-t lg:border-[#CECECE] px-[25px] pt-[25px] pb-40 flex-col lg:absolute md:w-[690px] w-full left-0 md:left-[250px] lg:hidden lg:group-hover:flex z-10 font-opensans text-base`}
                    // style={style}

                    className={` ${
                      activeMenu === "tools" ? "block" : "hidden"
                    } nav menu list languages_menu_child  lg:bg-[#060606] bg-transparent text-white lg:mt-[-5px] mt-[10px] lg:w-[600px] w-full left-0 top-[100px] lg:border-t lg:border-[#CECECE] place-content-center place-items-start z-10 lg:absolute px-4 pt-[25px] pb-40 lg:ml-[250px]  rounded-b-lg `}
                  >
                    <div className="grid grid-cols-2 gap-4">
                       {/* {HeaderToolsList.map(
                          ({ text, href, img_link }, index) => (
                            <li
                              key={index}
                              className={`hover:text-orange hover:underline hover:underline-offset-4 font-normal font-opensans ${
                                index === 0 ? "mt-0" : "mt-5"
                              }`}
                            >
                              <Link
                                className="hover:text-orange leading-[16px] text-sm  font-normal font-opensans py-1 flex gap-[10px] items-center"
                                to={href}
                              >
                                {img_link && (
                                  <img
                                    src={img_link}
                                    alt={text}
                                    className="w-5 h-5"
                                  />
                                )}
                                <span className={`${img_link && ""}`}>
                                  {text}
                                </span>
                              </Link>
                            </li>
                          )
                        )} */}
                      <div className="flex flex-col items-start pr-4  border-r border-[#D9D9D9] border-opacity-50">
                       
                        {HeaderToolsList.filter((tool) => tool.key === "pre").map(
                          ({ text, href, img_link }, index) => (
                            <li
                              key={index}
                              className={`hover:text-orange hover:underline hover:underline-offset-4 font-normal font-opensans ${
                                index === 0 ? "mt-0" : "mt-5"
                              }`}
                            >
                              <Link
                                className="hover:text-orange leading-[16px] text-sm  font-normal font-opensans py-1 flex gap-[10px] items-center"
                                to={href}
                              >
                                {img_link && (
                                  <img
                                    src={img_link}
                                    alt={text}
                                    className="w-5 h-5"
                                  />
                                )}
                                <span className={`${img_link && ""}`}>
                                  {text}
                                </span>
                              </Link>
                            </li>
                          )
                        )}
                      </div>

                      <div className="flex flex-col items-start pl-3">
                        
                        {HeaderToolsList.filter((tool) => tool.key === "post").map(
                          ({ text, href, img_link }, index) => (
                            <li
                              key={index}
                              className={`hover:text-orange hover:underline hover:underline-offset-4 font-normal font-opensans ${
                                index === 0 ? "mt-0" : "mt-5"
                              }`}
                            >
                              <Link
                                className="hover:text-orange leading-[16px] text-sm font-normal font-opensans py-1 flex gap-[10px] items-center"
                                to={href}
                              >
                                {img_link && (
                                  <img
                                    src={img_link}
                                    alt={text}
                                    className="w-5 h-5"
                                  />
                                )}
                                <span className={`${img_link && ""}`}>
                                  {text}
                                </span>
                              </Link>
                            </li>
                          )
                        )}
                      </div>
                    </div>
                    <div className="flex items-end justify-end mt-4  w-full">
                      <Link to="/tools">
                        <button className="flex items-center gap-2 hover:text-orange hover:underline hover:underline-offset-4">
                        More AI Tools
                          {/* <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="#5B93FF" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="#5B93FF"
                          >
                            <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
                          </svg>
                        </button>
                      </Link>
                    </div>
                  </ul>
                </li>

                <li className="leading-[16px] lg:px-4 w-full lg:py-10 lg:mb-0 mb-[34px] px-3 mx-1 text-sm group">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(
                        activeMenu === "company" ? false : "company"
                      )
                    }
                  >
                    Company
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "company" ? "rotate-180 text-orange" : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <div
                    className={`${
                      activeMenu === "company" ? "block" : "hidden"
                    } items-center justify-center lg:bg-[#060606] bg-transparent text-white  lg:mt-[-5px] mt-[10px] rounded-b-lg top-[100px] lg:border-t lg:border-[#CECECE] px-[25px] pt-[25px] pb-40 flex-col lg:absolute md:w-[480px] w-full left-0 md:left-[500px] lg:hidden lg:group-hover:flex z-10 font-opensans text-base`}
                    // style={style}
                  >
                    <h3 className="font-opensans font-normal text-sm leading-7">
                      We are a translation company committed to providing
                      high-quality professional translation services to
                      businesses in the United States and around the world.
                    </h3>
                    <div className="border border-[#FFFFFF] mt-6 w-full" />
                    <ul className=" nav menu list font-normal font-opensans w-full text-left list-inside grid grid-cols-2">
                      {AboutData?.map(({ link, list }, index) => (
                        <li
                          className="leading-[16px] text-sm mt-6 hover:underline hover:underline-offset-4 hover:text-orange font-opensans"
                          key={index}
                        >
                          <Link to={link}>{list}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li className="lg:inline-block hidden leading-[16px] px-3 lg:px-4 ml-1 mr-2 ">
                  <Link
                    to="/contactus.php"
                    className="text-sm flex gap-2.5 items-center justify-center hover:bg-white cursor-pointer whitespace-nowrap lg:transition-colors border border-white hover:text-black rounded-full py-2.5 px-6 font-bold"
                  >
                    <img src={greenIcon} />
                    <span className="uppercase"> Contact Us</span>
                  </Link>
                </li>
              </ul>
              <Link
                to="/quote"
                className="hidden lg:inline-block leading-[1] uppercase font-opensans font-bold text-center rounded-full py-3 bg-orange hover:bg-newOrange-100 text-white text-sm cursor-pointer w-[153px] h-[40px]"
              >
                {variant == "1" ? "START TRANSLATION" : " Translate Now"}
              </Link>
              <div className="mt-10 lg:hidden flex flex-col gap-6 md:items-center">
                <Link
                  to="/quote"
                  className="block md:inline-block md:w-[450px] uppercase rounded-full bg-orange hover:bg-newOrange-100 font-opensans font-semibold text-gray cursor-pointer text-14 text-center py-5"
                >
                  {variant == "1" ? "START TRANSLATION" : " Translate Now"}
                </Link>
                <Link
                  to="/user/login"
                  className="block md:inline-block md:w-[450px] uppercase rounded-full border-2 border-white font-opensans font-semibold text-gray cursor-pointer text-14 text-center py-5"
                >
                  <FontAwesomeIcon
                    icon={faUser}
                    className="mr-2 text-white w-[10px]"
                  />
                  Account
                </Link>
              </div>
              <div className="mt-6 flex items-center justify-center">
                <Link
                  to="/user/provider/createaccount"
                  className="lg:hidden flex text-white text-[13px] leading-[19.5px] font-primary  items-center  border-[#D9D9D9] "
                >
                  Register as a Translator
                </Link>
              </div>
              {/* <div className="mt-6 flex items-center justify-center">
                <Link
                  to="/translators"
                  className="lg:hidden flex text-white text-[13px] leading-[19.5px] font-primary  items-center  border-[#D9D9D9] "
                >
                  Our Translators
                </Link>
              </div> */}
              {/* <div className={`block lg:hidden `}>
                <p
                  className="mt-6 font-opensans xs:font-secondary text-14 text-gray flex justify-center items-center gap-2 cursor-pointer"
                  // onClick={() => {
                  //   // setShowTools((showTools) => !showTools);
                  //   setShowTools(!showTools);
                  //   // setActiveMenu(false);
                  // }}
                  onClick={showtoolsdata}
                >
                  <span>Tools</span>{" "}
                  <span
                    className={` ${
                      showTools
                        ? "rotate-180 transition duration-360 ease-in-out"
                        : "rotate-0 transition duration-360 ease-in-out"
                    }`}
                  >
                    {caretDownFil}
                  </span>
                </p>

                {showTools && (
                  <div className="w-full h-[300px] absolute top-[260px] right-0 bottom-0 left-0 z-[101] grid place-items-center  opacity-[95%]">
                    <div className="usa_modal h-[300px] min-w-[300px] overflow-scroll rounded-md">
                      <div className="usa_modal_body bg-white  p-4  space-y-4">
                        {toolsLinks?.map((link, index) => (
                          <Link
                            key={index}
                            href={link.href}
                            hreflang={link.hreflang}
                            className="text-black font-opensans text-base hover:text-lightBlue block"
                          >
                            {link.text}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div> */}
              <div
                className={`block lg:hidden ${showModal ? "hidden" : "block"}`}
              >
                <p
                  className="mt-6 font-opensans xs:font-secondary text-14 text-gray flex justify-center items-center gap-2 cursor-pointer"
                  onClick={() => {
                    setShowModal((showModal) => !showModal);
                    setActiveMenu(false);
                  }}
                >
                  <img
                    src="https://tomedes.gumlet.io/assets/images/usa.svg"
                    alt="languages"
                  />{" "}
                  <span>USA - EN</span> <span>{caretDownFil}</span>
                </p>
              </div>
            </nav>
          </section>
        </div>
        {showModal && (
          <div className="w-full h-full absolute top-0 right-0 bottom-0 left-0 z-[101] grid place-items-center bg-black opacity-[95%]">
            <div className="usa_modal h-[300px] w-[300px] overflow-scroll">
              <div className="usa_modal_head bg-midBlue pl-6 pr-3 font-opensans xs:font-secondary text-14 text-gray flex justify-between items-center gap-2">
                <p className="flex items-center gap-4 cursor-pointer">
                  <img
                    src="https://tomedes.gumlet.io/assets/images/usa.svg"
                    alt="languages"
                  />{" "}
                  <span className="text-orange">USA - EN</span>
                </p>
                <span
                  className="cursor-pointer"
                  onClick={() => setShowModal((showModal) => !showModal)}
                >
                  {closeModalIcon}
                </span>
              </div>
              <div className="usa_modal_body bg-[#000D21] text-gray pl-6 py-2 space-y-3">
                <a
                  hreflang="en-us"
                  href="https://www.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  English
                </a>
                <a
                  hreflang="es"
                  href="https://es.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Español
                </a>
                <a
                  hreflang="cn"
                  href="https://cn.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  简体中文
                </a>
                <a
                  hreflang="cn"
                  href="https://tw.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  中國傳統的
                </a>
                <a
                  hreflang="de"
                  href="https://de.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Deutsch
                </a>
                <a
                  hreflang="fr"
                  href="https://fr.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Français
                </a>
                <a
                  hreflang="nl"
                  href="https://nl.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Nederlands
                </a>
                <a
                  hreflang="he"
                  href="https://www.tomedes.co.il/"
                  target="_blank"
                  className="block"
                >
                  עברית
                </a>
                <a
                  hreflang="ja"
                  href="https://jp.tomedes.com"
                  target="_blank"
                  className="block"
                >
                  日本語
                </a>
                <a
                  hreflang="ko"
                  href="https://kr.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  한국어
                </a>
                <a
                  hreflang="nb"
                  href="https://no.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Norsk
                </a>
                <a
                  hreflang="pl"
                  href="https://pl.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Polski
                </a>
                <a
                  hreflang="ro"
                  href="https://ro.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Româna
                </a>
                <a
                  hreflang="sv"
                  href="https://sv.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Svenska
                </a>
                <a
                  hreflang="tr"
                  href="https://tr.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Türk
                </a>
                <a
                  hreflang="ru"
                  href="https://ru.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Русский
                </a>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
}
